const FullScreenLoading = ({ message }: { message: string }) => (
  <div className='w-full h-screen bg-teal-200 flex flex-col justify-center items-center flex-nowrap'>
    <div className='animate-spin rounded-full h-24 w-24 border-b-4 border-gray-400' />
    <p className='text-lg font-medium'>{message}</p>
  </div>
)

export default FullScreenLoading
